import { useCallback } from 'react';
import { getInstance } from 'ag-grid-react';


export default function useToggleableStatusBar(gridRef) {
  return useCallback((visible) => {
    getInstance(gridRef.current.api.getStatusPanel('statusBarCompKey'), (statusBarComponent) => {
      statusBarComponent.setVisible(visible);
    });
  }, []);
}